import { ActionReducerMap } from '@ngrx/store';
import * as fromAuthData from './auth-data.reducer';
import * as fromDealerFeatures from './authorization.reducer';
import * as fromAppNavBar from './app-navbar.reducer';
import { AppNotificationStateReducer } from './app-notification.reducer';
import { AppStatusStateReducer } from './app-status.reducer';
import { IAppCoreState } from '..';
import * as fromAppChat from './app-chat.reducer';
//import * as fromRouter from '@ngrx/router-store';
// import { GlobalNotificationReducer } from './global-notification.reducer';
 
//
// AppCoreState Reducers
//
export const reducers: ActionReducerMap<IAppCoreState> = {
  AuthData: fromAuthData.reducer,
  AuthAccessData: fromDealerFeatures.reducer,
  navbar: fromAppNavBar.reducer,
  notification: AppNotificationStateReducer, 
  chat: fromAppChat.reducer,
  appStatus: AppStatusStateReducer

};
 
